import { ProjectDto } from '@/core';
import { getColumnSettings } from '@/pages/Projects.Constructor';

export const findColumnNameById = (columnId: string, projectData: ProjectDto) => {
  const column = projectData.columns.find((x) => x.id === columnId);
  if (!column) return '';
  if (getColumnSettings(column.type).isDefault) {
    return getColumnSettings(column.type).label;
  }
  return column.name;
};
